<template>
<div id="vista-listado">
    <div v-if="data" class="container mt-4">
        <!-- <h1 style="color:brown;" v-if="filtros">SI HAY FILTROS {{filtros}}</h1>
        <h1>lista de articulos</h1> -->

        <!-- <div class="d-flex">
            <h3>filtros =  _</h3>
            <h3 v-if="tipo == 1">comunicado -</h3>
            <h3 v-else-if="tipo == 2">Boletin -</h3>
            <h3 v-else>todo - </h3>
            <h3> {{anio_}} </h3>
        </div>
        {{mes_ano}}
        <hr> -->

        <!-- <code>{{data}} </code> -->

        <!-- SI BUSCA UNA CLASIFICACION (BOLETIN - COMUNICADO) Y NO EXISTE -->
        <div v-if="!existe_articulo" class="text-center my-5">
            <p class="sinResult text-muted">No se hallaron {{tipo==1? 'comunicados' : 'boletines'}} en la fecha consultada</p>
            <i class="far fa-frown fa-2x text-muted"></i>
        </div>

        <!-- SI HACE UNA CONSULTA Y NO TIENE RESULTADOS -->
        <div v-if="JSON.stringify(data) == '[]'" class="text-center my-5">
           <p class="sinResult text-muted">Sin resultados en la fecha consultada</p>
            <i class="far fa-frown fa-2x text-muted"></i>
        </div>
        <!-- <code v-for="(datos, j) in data" :key="j">
            {{titularURL(datos.titulo)}}
        </code> -->
        <!--  --------------- FILTRA LA RESPUESTA POR CATEGORIA (BOLETIN - COMUNICADO - TODOS) ----------------- -->
        <div v-for="(datos, i) in data" :key="i" class="contenido-servicio">
            <div v-if="tipo == 3" class="mb-4">
                <router-link :to="`/prensa/vista-detalle/${datos.idarticulo}/${titularURL(datos.titulo)}`">
                    <h3 :class="modoDark_var? 'text-white' : ''"> {{ datos.titulo.toUpperCase() }} </h3> <!--({{ datos.idclasificacion }})-->
                    <p class="fecha_" :class="modoDark_var? 'text-white' : 'text-muted'"> {{ datos.fecha_articulo }} </p>

                   <img v-if="datos.url_recurso" :src="datos.url_recurso" class="card-img-top"  style="height:300px; object-fit: cover; width:100%">
                    <img v-else src="@/assets/imagenes/sin_imagen.png" :alt="datos.titulo" style="height:300px; object-fit: cover; width:100%">
                    <p class="texto-articulo text-justify mb-4 mt-2" :class="modoDark_var? 'text-white' : 'text-muted'">
                        {{datos.resumen}}
                        ...<span :class="modoDark_var? 'text-white' : 'colorNormal'">Leer más</span>
                    </p>
                        <!-- Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut eveniet veniam non ea doloribus, qui quod incidunt sed saepe officia illum in quidem impedit vero eius sapiente quos sit sunt! -->
                    <hr>
                </router-link>
            </div>
            <div v-else-if="datos.idclasificacion == tipo" class="mb-4">
                    <router-link :to="`/prensa/vista-detalle/${datos.idarticulo}/${titularURL(datos.titulo)}`">
                        <h3 :class="modoDark_var? 'text-white' : ''"> {{ datos.titulo.toUpperCase() }} </h3> <!---({{ datos.idclasificacion }})-->
                        <p class="fecha_" :class="modoDark_var? 'text-white' : 'text-muted'"> {{ datos.fecha_articulo }} </p>

                        <img v-if="datos.url_recurso" :src="datos.url_recurso" class="card-img-top"  style="height:300px; object-fit: cover; width:100%">
                        <img v-else src="@/assets/imagenes/sin_imagen.png" :alt="datos.titulo" style="height:300px; object-fit: cover; width:100%">
                        <p class="texto-articulo text-justify mb-4 mt-2" :class="modoDark_var? 'text-white' : 'text-muted'">
                            {{datos.resumen}}
                            ...<span :class="modoDark_var? 'text-white' : 'colorNormal'">Leer más</span>
                        </p>
                            <!-- Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio impedit repellat fugit, amet quidem voluptatibus. Aut nihil magni impedit minus numquam iusto nobis quaerat itaque consequuntur eaque, iure, doloribus ad? -->
                        <hr>
                    </router-link>
            </div>
        </div>

    </div>
</div>
</template>

<script>
$('#myModal').on('shown.bs.modal', function () {
  $('#myInput').trigger('focus')
})

import { mapState } from "vuex";
import { mapMutations } from 'vuex'
import axios from "axios"
export default {
    data: function(){
        return {
            data: null,
            filtros: this.$route.params.filtros,
            categoria: 3,
            url: this.$urlServidor+'SalaDePrensa/api/api/Sala/',
            existe_articulo: false,
        }
    },
    computed:{
        ...mapState(['tipo', 'anio_', 'mes_ano', 'anio_actual', 'modoDark_var'])
    },
    methods:{
        ...mapMutations(['anio', 'clasificacion', 'mes_anio', 'inicializar_v_listado']),

        /** entra una cadena, ejm: 'titular de prensa', reemplaza espaciados
         * @returns 'titular-de-prensa'
         */
        titularURL(titulo){
            let tituloNuevo = titulo;
            let huboEspacio = true;

            while(huboEspacio){
                if(tituloNuevo.indexOf(' ') > 0){
                    tituloNuevo = tituloNuevo.replace(' ', '-');
                }
                else huboEspacio = false;
            }
            return tituloNuevo;

        },

        //  CONSULTA LOS ARTICULOS POR AÑO
        // SI VIENE FILTRO AÑO, SINO AÑO VIENE DE VARIABLE MES_ANO DEL STORE
        // O SINO, HACE LA CONSULTA CON EL AÑO MAS RECIENTE CON ARTICULO
        servicioPrensa(annio_filtro){
            // console.log('servicioPrensa()');

            if(annio_filtro) var ano = annio_filtro;
            else{
                var ano = (this.anio_ > 0)? this.anio_ : this.anio_actual;
            }

            axios.get(this.url+'Articulos/'+ano)
            .then(response => {
                this.data = response.data;
                console.log(this.data);
            })
            .catch(function (error) {
                console.log(error);
            });

        },



        //| FUNCION QUE CONSULTA LOS ARTICULOS POR MES-AÑO |\\
        // this.mes_ano = 2021-02 | transformar a 2021/02
        // SI VIENE FILTRO MES-AÑO, SINO MES-AÑO VIENE DE VARIABLE MES_ANO DEL STORE
        servicio_Mes_Ano(filtro){
            var cadena = filtro? filtro : this.mes_ano;
            var fecha = cadena.substring(0,4) +'/'+cadena.substring(5,7);

            axios.get(this.url+'Articulos_mes/'+fecha)
            .then(response => {
                this.data = response.data;
                console.log(this.data);
            })
            .catch(function (error) {
                console.log(error);
            });
        },



        // CHECA SI AL INICIALIZAR LA RUTA TRAE ALGUN FILTRO
        // EL FILTRO PUEDE SER MES-AÑO, O AÑO
        // SINO, ENTONCES VIENE LA RUTA SIN FILTROS
        validacion_filtro(){
            if(this.filtros){
                if(this.filtros.length > 5){
                    this.servicio_Mes_Ano(this.filtros)
                }else{
                    this.servicioPrensa(this.filtros)
                }
            }else{
                this.servicioPrensa();
            }
        },


        // SI VERIFICACION DE RUTA. SI ESTA EN VISTA-LISTADO/, LE AÑADE EL AÑO (MAS RECIENTE CON ARTICULOS) A LA RUTA
        validar_ruta(){
            if(window.location.pathname == '/prensa/vista-listado' || window.location.pathname == '/prensa/vista-listado/'){
                this.$router.push(`/prensa/vista-listado/${this.anio_actual}`);
            }
        },



        // VERIFICA EL TIPO DE ARTICULO BUSCADO EN FILTRO CATEGORIA (BOLETIN, COMUNICADO, TODO)
        // SI NO EXISTE UN ARTICULO CON ESE TIPO EN ESA BUSQUEDA, PODRA MOSTRAR UN MSJ DE NO ENCONTRADO
        consulta_tipo(data, tipo){
            this.existe_articulo = false;
            if(tipo == 3) this.existe_articulo = true;
            else{
                for(var i=0; i<=data.length-1; i++){
                    if(data[i].idclasificacion == tipo) this.existe_articulo = true;
                    // console.log('data['+i+'].idclasificacion '+data[i].idclasificacion +' tipo '+ tipo);
                }
            }
        }



    },
    mounted(){
        window.scrollTo(0, 0);
        this.validacion_filtro();
    },
    created(){
        this.validar_ruta();
        this.inicializar_v_listado();
    },
    watch:{
        //CUANDO HAY CAMBIOS EN ESTAS VARIABLES SE LLAMAN SERVICIOS
        anio_: function(){
             this.servicioPrensa();
             //CAMBIAR TIPO PARA Q NO AFECTE TIPO
             //DE BUSQDA CLASIFICACION
             this.clasificacion('3');
        },
        mes_ano: function(){
             this.servicio_Mes_Ano();
              //CAMBIAR TIPO PARA Q NO AFECTE TIPO
             //DE BUSQDA CLASIFICACION
             this.clasificacion('3');
        },
        tipo: function(){
            // VARIA CONSULTA EL TIPO DE CLASIFICACION
            // VALIDA SI NO HAY ARTICULOS DE ESE TIPO
            this.consulta_tipo(this.data, this.tipo);
        },
        data: function(){
            this.consulta_tipo(this.data, this.tipo);
        }

    }

}
</script>

<style scope>
  .colorNormal{color:#621132}
    .container{max-width: 1240px !important;}
    .container hr{ border: .5px solid #eee !important; }

    .contenido-servicio{ color: #555; }
    .contenido-servicio div > h3{ font-size: 1.6rem; }

    .fecha_{
        border-top: 3px solid #9b9b9b;
        display: inline-block;
        /* color:#9b9b9b; */
        /* font-size:.9rem; */
    }
    #vista-listado p {
        /* font-size: 1.2rem; */
        color: #292828;
    }

    a{ color: #555; }
    a:hover{
        color: #555;
        text-decoration: none;
    }


</style>
